import React from "react";
import { get } from "lodash";

import StarRating from "../../../../sharedComponents/starRating";
import PlaceholderIMG from "../../../../sharedComponents/placeholderImage";
import { RecipeKeys } from "../../../../constants/recipeConstants";
import Tooltip from "../../../../sharedComponents/tooltip";

const RecipesCard = ({ cardInfo, history, className = "", edit, declineRecipe }) => {
	const renderRangeItems = (cardInfo) => {
		const rangeItems = [
			{
				key: RecipeKeys.CALORIES,
				label: "Calories",
				unit: "k"
			},
			{
				key: RecipeKeys.PHASE,
				label: "Phase",
				unit: ""
			}
		];
		return rangeItems.map((item) => (
			<div key={item.key} className="card-block">
				<div className="card-field-value">
					{cardInfo[item.key]} {item.unit}
				</div>
				<div className="card-field-label">{item.label}</div>
			</div>
		));
	};

	const renderApproveNavs = (cardInfo) => {
		return (
			<div className="text-center flex-fill px-1">
				<button className="btn btn-light mr-2 btn-sm" onClick={() => declineRecipe(cardInfo)}>
					Decline
				</button>
				<button
					className="btn btn-primary-dark mr-2 btn-sm"
					onClick={() => history.push(`/nutrition/recipes/${cardInfo.id}/edit`)}>
					Approve
				</button>
			</div>
		);
	};

	const mainImage = get(cardInfo, "main_image.photo_m") || get(cardInfo, "images[0].image_data.photo_m") || null;

	return (
		<div
			key={cardInfo[RecipeKeys.ID]}
			className={`card card-primary ${className} ${(!edit || !edit.navs) && !cardInfo.active ? "inactive" : ""}`}>
			{edit && edit.allow && !edit.navs ? (
				<div className="card-nav">
					<Tooltip content="Edit Recipe">
						<button
							className="btn btn-light btn-cell btn-sm"
							onClick={() => history.push(`/nutrition/recipes/${cardInfo.id}/edit`)}>
							<i className="icon icon-edit" />
						</button>
					</Tooltip>
				</div>
			) : null}
			<div className="card-header" onClick={() => history.push(`/nutrition/recipes/${cardInfo.id}/details`)}>
				<div className="card-image">
					<PlaceholderIMG
						src={mainImage}
						width="236"
						height="215"
						bg="rgba(0,0,0,0.1)"
						alt={cardInfo[RecipeKeys.NAME]}
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
					/>
				</div>
				<div className="card-header-data">
					<div className="card-header-tags">
						{/* {!cardInfo.active && <div className="tag tag-warning">Pending</div>} */}
						{cardInfo.featured && <div className="tag tag-primary-dark">Featured</div>}
					</div>
					<div className="card-header-title">{cardInfo[RecipeKeys.NAME]}</div>
					{edit && edit.navs ? null : (
						<div className="card-header-body">
							<div className="card-star">
								<StarRating value={cardInfo[RecipeKeys.RATING]} onUpdate={() => {}} />
							</div>
							<div className="card-comment">
								<i className="icon icon-comment" /> {cardInfo[RecipeKeys.COMMENTS]}
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="card-body">
				{edit && edit.allow && edit.navs ? renderApproveNavs(cardInfo) : renderRangeItems(cardInfo)}
			</div>
		</div>
	);
};

export default RecipesCard;
